export default {
  default: '/',
  pastebin: '/pastebin',
  pastebinId: '/pastebin/:id',
  sourceCode: '/source-code',
}